import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { MyWorkOrdersComponent } from './my-work-orders/my-work-orders.component';
import { RequestWorkOrdersComponent } from './request-work-orders/request-work-orders.component';
import { MCXSamplepage } from './cloneMCX/mcx-samplepage/mcx-samplepage';
import { HomePageComponent } from './homepage/home-page/home-page';
import { CommunityCalendarPage } from './homepage/community-calendar-page/community-calendar-page';
import { PayMyRent } from './homepage/pay-my-rent/pay-my-rent';
import { PropertyDetailsPage } from './homepage/property-details-page/property-details-page';


export const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'home', component: HomePageComponent },
  { path: 'community-calendar', component: CommunityCalendarPage },
  { path: 'pay-my-rent', component: PayMyRent },
  { path: 'my-work-orders', component: MyWorkOrdersComponent },
  { path: 'request-work-orders', component: RequestWorkOrdersComponent },
  { path: 'clone-mcx', component: MCXSamplepage },
  { path: 'app-property-details-page', component: PropertyDetailsPage}
];
